
            <div class="container">
                <nav class="navbar navbar-expand-lg ">
                    <div class="container-fluid">
                      <a class="navbar-brand" href="#"><img src="./img/logo-1.png" alt=""></a>
                      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                      </button>
                      <div class="collapse navbar-collapse" id="navbarText">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                          <li class="nav-item">
                            <a class="nav-link active" aria-current="page" href="#">Home</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" href="#">Features</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" href="#">Pricing</a>
                          </li>
                        </ul>
                        <span class="navbar-text">
                         <ul>
                            <li>Login</li>
                            <li>Register</li>
                            <li><button class="btn" type="button">Sell your car</button></li>
                         </ul>
                        </span>
                      </div>
                    </div>
                  </nav>
            </div>
        
        <!-- header area end -->

        <!-- hero area start -->
        <section class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <h2>Find Your Dream Car</h2>
                        <p>Our CarSpot experts inspect the car on over 200 checkpoints so you get complete satisfaction and peace.</p>
                        <ul>
                            <li><i class="fa-solid fa-hand-point-right"></i> Post your car's ad for free in 30 seconds. </li>
                            <li><i class="fa-solid fa-hand-point-right"></i>  Get authentic offers from verified buyers.</li>
                            <li><i class="fa-solid fa-hand-point-right"></i>  Sell your car faster than others at a better price.</li>
                        </ul>

                        <img src="./img/e.png" class=" car" alt="">
                    </div>

                    <div class="col-md-2"></div>

                    <div class="col-md-4 ml-auto">
                        <div class="bookingBox">
                            <h3>Find Your Right Car</h3>
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">

                                <li class="nav-item" role="presentation">
                                  <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">New Car</button>
                                </li>

                                <li class="nav-item" role="presentation">
                                  <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Used Car</button>
                                </li>
                             
                              </ul>
                              <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">

                                    <div class="form-check form-check-inline activeRadio">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" checked>
                                        <label class="form-check-label" for="inlineRadio1">By Budget</label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
                                        <label class="form-check-label" for="inlineRadio2">By Brand</label>
                                    </div>
                                

                                    <select class="form-select border-bottom-0 mt-4" aria-label="Default select example">
                                        <option selected>Select Budget</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>

                                      <select class="form-select" aria-label="Default select example">
                                        <option selected>All Vehicle Type</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>

                                      <button class="btn" type="button">Search</button>
                                </div>

                                <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">

                                    <div class="form-check form-check-inline activeRadio">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" checked>
                                        <label class="form-check-label" for="inlineRadio1">By Budget</label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
                                        <label class="form-check-label" for="inlineRadio2">By Brand</label>
                                    </div>
                                

                                    <select class="form-select border-bottom-0 mt-4" aria-label="Default select example">
                                        <option selected>Select Budget</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>

                                      <select class="form-select" aria-label="Default select example">
                                        <option selected>All Vehicle Type</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>

                                      <button class="btn" type="button">Search</button>

                                </div>

                                
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- hero area end -->

        <!-- most searched car -->

        <div class="mostSearched">
            <div class="container">
                <h5>The most searched cars</h5>

                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-hom" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Hatchback</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profil" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Sedan</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-conta" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">SUV</button>
                    </li>

                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-cont" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">MUV</button>
                    </li>

                      <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-con" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Luxury</button>
                      </li>
                   
                  </ul>

                  <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-hom" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">

                        <div class="owl-carousel owl-theme" id="hatchBag">
                            <div class="item">
                                <div class="card">
                                    <img src="./img/1.jpg" alt="">
                                    <div class="card-body">
                                        <h5>Renault KWID</h5>
                                        <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                        <button class="btn" type="button">View All Offer</button>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="card">
                                    <img src="./img/1.jpg" alt="">
                                    <div class="card-body">
                                        <h5>Renault KWID</h5>
                                        <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                        <button class="btn" type="button">View All Offer</button>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="card">
                                    <img src="./img/1.jpg" alt="">
                                    <div class="card-body">
                                        <h5>Renault KWID</h5>
                                        <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                        <button class="btn" type="button">View All Offer</button>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="card">
                                    <img src="./img/1.jpg" alt="">
                                    <div class="card-body">
                                        <h5>Renault KWID</h5>
                                        <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                        <button class="btn" type="button">View All Offer</button>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="card">
                                    <img src="./img/1.jpg" alt="">
                                    <div class="card-body">
                                        <h5>Renault KWID</h5>
                                        <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                        <button class="btn" type="button">View All Offer</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <a href="#" class="viewAll">View All Hatchbag Cars</a>

                    </div>

                    <div class="tab-pane fade" id="pills-profil" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">..</div>

                    <div class="tab-pane fade" id="pills-contac" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">...</div>
                   
                    <div class="tab-pane fade" id="pills-conta" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">...</div>

                    <div class="tab-pane fade" id="pills-cont" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">...</div>
                  </div>

            </div>
        </div>

        <div class="latestCar">
            <div class="container">
                <h5>Latest Car</h5>

                <div class="owl-carousel owl-theme" id="latestCar">
                    <div class="item">
                        <div class="card">
                            <img src="./img/1.jpg" alt="">
                            <div class="card-body">
                                <h5>Renault KWID</h5>
                                <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                <button class="btn" type="button">View All Offer</button>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="card">
                            <img src="./img/1.jpg" alt="">
                            <div class="card-body">
                                <h5>Renault KWID</h5>
                                <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                <button class="btn" type="button">View All Offer</button>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="card">
                            <img src="./img/1.jpg" alt="">
                            <div class="card-body">
                                <h5>Renault KWID</h5>
                                <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                <button class="btn" type="button">View All Offer</button>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="card">
                            <img src="./img/1.jpg" alt="">
                            <div class="card-body">
                                <h5>Renault KWID</h5>
                                <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                <button class="btn" type="button">View All Offer</button>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="card">
                            <img src="./img/1.jpg" alt="">
                            <div class="card-body">
                                <h5>Renault KWID</h5>
                                <h3>Rs 4.62 - 5.96 Lakh*</h3>
                                <button class="btn" type="button">View All Offer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <a href="#" class="viewAll">View All Hatchbag Cars</a>
            </div>
        </div>

        <div class="ad text-center">
            <img src="./img/ad.png" class="img-fluid" alt="">
        </div>

        <div class="popularBrand">
            <div class="container">
                <h5>Popular Brands</h5>

                <div class="row">
                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/1.webp" alt="">
                            <p>Maruti</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/2.webp" alt="">
                            <p>Hyndai</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/3.webp" alt="">
                            <p>Tata</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/4.webp" alt="">
                            <p>Mahindra</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/5.webp" alt="">
                            <p>Kia</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/6.webp" alt="">
                            <p>Mercedes</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/7.webp" alt="">
                            <p>Renault</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/8.webp" alt="">
                            <p>Honda</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/9.webp" alt="">
                            <p>MG</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/10.webp" alt="">
                            <p>Nissan</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/11.webp" alt="">
                            <p>Datsun</p>
                        </div>
                    </div>

                    <div class="col-md-2 col-6">
                        <div class="card">
                            <img src="./img/1.webp" alt="">
                            <p>Toyota</p>
                        </div>
                    </div>
                </div>

                <a href="#" class="viewAll">View All Popular Brands</a>
            </div>
        </div>

        <div class="banner">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <img src="./img/man.png" class="man" alt="">
                    </div>
                    <div class="col-md-5 my-auto">
                        
                        <h2>Not Sure, Which car to buy?</h2>
                        <p>Let us help you find the dream car</p>
                    </div>

                    <div class="col-md-3 my-auto">
                        <button class="btn" type="button">Find Your Car</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="compare">
            <div class="container">
                <h5>Compare Cars</h5>

                <div class="owl-carousel owl-theme" id="compare">
                    <div class="item">
                        <div class="card">
                            <div class="compareBox">
                                <div class="car1">
                                    <img src="./img/c1.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                                <span>VS</span>
                                <div class="car2">
                                    <img src="./img/c2.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                            </div>

                            <button class="btn" type="button">Compare</button>
                        </div>
                    </div>
                    
                    <div class="item">
                        <div class="card">
                            <div class="compareBox">
                                <div class="car1">
                                    <img src="./img/c1.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                                <span>VS</span>
                                <div class="car2">
                                    <img src="./img/c2.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                            </div>
                            <button class="btn" type="button">Compare</button>
                        </div>
                    </div>

                    <div class="item">
                        <div class="card">
                            <div class="compareBox">
                                <div class="car1">
                                    <img src="./img/c1.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                                <span>VS</span>
                                <div class="car2">
                                    <img src="./img/c2.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                            </div>
                            <button class="btn" type="button">Compare</button>
                        </div>
                    </div>

                    <div class="item">
                        <div class="card">
                            <div class="compareBox">
                                <div class="car1">
                                    <img src="./img/c1.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                                <span>VS</span>
                                <div class="car2">
                                    <img src="./img/c2.png" alt="">
                                    <h5>2016 Ford Escape Cape</h5>
                                    <p>Rs.10.44 - 18.18 Lakh</p>
                                    <div class="rating">
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                    </div>
                                </div>
                            </div>
                            <button class="btn" type="button">Compare</button>
                        </div>
                    </div>
                </div>

                <a href="#" class="viewAll">View All Cars</a>
            </div>
        </div>

        <div class="carInspection">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <img src="./img/car-in-red.png" class="img-fluid" alt="">
                    </div>
                    <div class="col-md-6">
                        <h6>Want To Sale Your Car ?</h6>
                        <h5>CAR INSPECTION</h5>
                        <p>Our CarSure experts inspect the car on over 200 checkpoints so you get complete satisfaction and peace of mind before buying.</p>
                        <div class="row">
                            <div class="col-md-4">
                                <ul>
                                    <li><i class="fa fa-check"></i> Transmission</li>
                                    <li><i class="fa fa-check"></i> Tires</li>
                                    <li><i class="fa fa-check"></i> Suspension</li>
                                    <li><i class="fa fa-check"></i> Air Conditioning</li>
                                </ul>
                            </div>
                            <div class="col-md-4">
                                <ul>
                                    <li><i class="fa fa-check"></i> Transmission</li>
                                    <li><i class="fa fa-check"></i> Tires</li>
                                    <li><i class="fa fa-check"></i> Suspension</li>
                                    <li><i class="fa fa-check"></i> Air Conditioning</li>
                                </ul>
                            </div>
                            <div class="col-md-4">
                                <ul>
                                    <li><i class="fa fa-check"></i> Transmission</li>
                                    <li><i class="fa fa-check"></i> Tires</li>
                                    <li><i class="fa fa-check"></i> Suspension</li>
                                    <li><i class="fa fa-check"></i> Air Conditioning</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <img src="./img/logo-1.png" class="logo" alt="">
                        <p class="mb-4">CarSpot Automotive Car Classified WordPress Theme is flexible and powerful Car Classified wordpress Theme for your all automotive & car listing business needs.</p>
                        <ul class="social">
                            <li><a href="#"><i class="fa-brands fa-facebook-f"></i> </a></li>
                            <li><a href="#"><i class="fa-brands fa-twitter"></i> </a></li>
                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i> </a></li>
                            <li><a href="#"><i class="fa-brands fa-google-plus-g"></i></a></li>
                            <li><a href="#"><i class="fa-brands fa-youtube"></i> </a></li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h5>Quick Links</h5>

                        <div class="d-flex">
                            <ul>
                                <li><a href="">Home</a></li>
                                <li><a href="">About Us</a></li>
                                <li><a href="">Comparison</a></li>
                                <li><a href="">Expert Reviews</a></li>
                            </ul>
    
                            <ul>
                                <li><a href="">Elements</a></li>
                                <li><a href="">Checkout</a></li>
                                <li><a href="">Packages</a></li>
                                <li><a href="">Contact Us</a></li>
                            </ul>
                        </div>
                     
                    </div>
                    <div class="col-md-3">
                        <h5>Get Our Apps</h5>
                        <a href="#" class="google">
                            <img src="./img/google.png" alt="">
                        </a>
                        <a href="#" class="apple">
                            <img src="./img/apple.png" alt="">
                        </a>
                    </div>

                    <div class="col-12 text-center">
                        <p class="copyright">© Copyright 2022  </p>
                    </div>
                </div>
            </div>
        </footer>
  